var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',{staticClass:"text-lg leading-6 font-medium text-gray-900"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),(_vm.description)?_c('p',{staticClass:"mt-1 text-sm text-gray-500"},[_vm._v(" "+_vm._s(_vm.description)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }